import { forwardRef, memo, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from "react"
import "./UI/AmarAkbarAntony.scss"
import AmarAkbarAntonyAnimationLayer from "./UI/AmarAkbarAntonyAnimationLayer"

// import AAA_Demo_img from "../../../../../assets/games/AmarAkbarAntony/Amar-Akber-Anthony-New-2.png"
import AAA_Demo_img from "../../../../../assets/games/AmarAkbarAntony/Amar_Akber_Anthony_Bg.webp"
import balance_img from "../../../../../assets/games/PaiGow/balance_img.png"
import winCup_img from "../../../../../assets/games/PaiGow/winCup_img.png"
import betChip_img from "../../../../../assets/games/PaiGow/betChip_img.png"
import AmarAkbarAntonyBoard from "./UI/AmarAkbarAntonyBoard"
import info_img from "../../../../../assets/games/AmarAkbarAntony/Bet_1.png"
import { Howl } from "howler"

import betChipSnd from "../../../../../assets/sounds/betoncard.mp3"
import cardFallSnd from "../../../../../assets/sounds/slide.mp3"
import msgSnd from "../../../../../assets/sounds/coindrop_old.mp3"
import clearSnd from "../../../../../assets/sounds/clear.mp3"
import loseSnd from "../../../../../assets/sounds/duplose.mp3"
import pokerChipSnd from "../../../../../assets/sounds/pokerChip.mp3"
import buttonClickSnd from "../../../../../assets/sounds/buttonClick.mp3"
import glowSnd from "../../../../../assets/sounds/successNew.mp3"
import invalidBetSnd from "../../../../../assets/sounds/alert.mp3"
import woodBrkSnd from "../../../../../assets/sounds/wood_break2.ogg"
import winMusicSnd from "../../../../../assets/sounds/winMusic.ogg"
import AnimalRevealSnd from "../../../../../assets/sounds/AnimalRevealSound.ogg"
import boxKnockSnd from "../../../../../assets/sounds/door-knocking.ogg"
import swingSnd from "../../../../../assets/sounds/sling-swing2.ogg"
import { changeAmountToFixed } from "../../../Utillitys/changeAmountToFixed"
import AmarAkbarAnthonyGameRules from "./UI/AmarAkbarAnthonyGameRules"
import useSafeTimeout from "../../../Utillitys/useSafeTimeout"



const AmarAkbarAntony = forwardRef((props, ref) => {

    const aaaAnimationRef = useRef()
    const [betAmount, setBetAmount] = useState(0)
    const [dupBetAmount, setDupBetAmount] = useState(0)
    const [winAmount, setWinAmount] = useState(0)
    const [betObject, setBetObject] = useState({ Amar: 0, Akbar: 0, Anthony: 0 })
    const [betBtn, setBetBtn] = useState()
    const [selectedChip, setSelectedChip] = useState({ value: props.aaa_chipValues?.split(",")[0], index: 0 })
    const [isBetFreezed, setIsBetFreezed] = useState(false)
    const [infoText, setInfoText] = useState(props.language.AAA_BetMsg);
    const [showWinAmount, setShowWinAmount] = useState(false)
    const [enterPopUp, setEnterPopUp] = useState(true);
    const [showGameRules, setShowGameRules] = useState(false)
    const [isDoubleDisabled, setDoubleDisabled] = useState(false)
    const [winner, setWinner] = useState("")
    const [betPlacedChipSize, setBetPlacedChipSize] = useState(window.innerHeight < window.innerWidth ? 90 : 135)
    const playingSound = useRef()
    const soundLoopTimeout = useRef()
    const soundsRef = useRef({});
    const isInitial = useRef(true)
    const timeOutRef = useRef()
    const betRequestTimeOut = useRef(null);
    const isFGA = useRef(process.env.REACT_APP_ISFGA === "true")
    const { setSafeTimeout } = useSafeTimeout()

    useImperativeHandle(ref, () => ({
        checkAmarAkbarAntonyResult,
        checkGameState,
        updateMessage,
        updatePlayerBalance: () => { setDupBetAmount(0) }
    }))

    useEffect(() => {
        const unlock = () => {
            if (!soundsRef.current?.cardFallSound) {
                soundsRef.current = {
                    betChipSound: new Howl({ src: [betChipSnd], html5: true }),
                    cardFallSound: new Howl({ src: [cardFallSnd], html5: true }),
                    messageSound: new Howl({ src: [msgSnd], html5: true }),
                    clearSound: new Howl({ src: [clearSnd], html5: true }),
                    lostSound: new Howl({ src: [loseSnd], html5: true }),
                    pokerChipSound: new Howl({ src: [pokerChipSnd], html5: true }),
                    winGlowSound: new Howl({ src: [glowSnd], html5: true }),
                    invalidBet: new Howl({ src: [invalidBetSnd], html5: true }),
                    woodBreak: new Howl({ src: [woodBrkSnd], html5: true }),
                    winMusic: new Howl({ src: [winMusicSnd], html5: true }),
                    AnimalReveal: new Howl({ src: [AnimalRevealSnd], html5: true }),
                    buttonClick: new Howl({ src: [buttonClickSnd], html5: true }),
                    swingSound: new Howl({ src: [swingSnd], html5: true }),
                    boxKnock: new Howl({ src: [boxKnockSnd], html5: true }),
                };
            }
            window.removeEventListener("touchstart", unlock);
            window.removeEventListener("click", unlock);
        };
        window.addEventListener("resize", handleOrientationChange)
        window.addEventListener("touchstart", unlock, { once: true });
        window.addEventListener("click", unlock, { once: true });
        props.assestsLoaderFunction()
        isInitial.current = false
        if (isFGA.current) {
            checkGameState()
        }
        return () => {
            clearTimeout(timeOutRef.current);
            window.removeEventListener("resize", handleOrientationChange);
        };
    }, [])

    useEffect(() => {
        if (showWinAmount) {
            playTheSound("winMusic")

            // Auto close after 3 seconds
            // const timer = setTimeout(() => {
            //     setShowWinAmount(false)
            //     aaaAnimationRef.current.setJokerToHistory(true)
            // }, 5000);
            setWinAmount(props.AmarAkbarAntonyResult.winAmount)
            setInfoText(`${props.language.You_won} ${props.AmarAkbarAntonyResult.winAmount}`)
            // return () => clearTimeout(timer);
        } else {
            if (!isFGA.current) {
                setWinAmount(0)
                if (!isInitial.current) {
                    setInfoText(props.language.AAA_BetMsg)
                }
            }
        }
    }, [showWinAmount]);

    useEffect(() => {
        if (winner) {
            clearTimeout(timeOutRef.current)
            if (props.AmarAkbarAntonyResult.winAmount) {
                if (!isFGA.current) {
                    timeOutRef.current = setTimeout(() => {
                        setShowWinAmount(true)
                        getGameStatePlayerBalance()
                    }, 2000)
                } else {
                    setShowWinAmount(true)
                    timeOutRef.current = setTimeout(() => {
                        setShowWinAmount(false)
                    }, 3000)
                }
            }
            else {
                if (!isFGA.current) {
                    timeOutRef.current = setTimeout(() => {
                        getGameStatePlayerBalance()
                    }, 500)
                }
            }
        }
    }, [winner])

    useEffect(() => {
        if (betObject) {
            let totalAmount = changeAmountToFixed(Object.values(betObject).reduce((a, b) => a + Number(b), 0), 2)
            setBetAmount(totalAmount)
            setDupBetAmount(totalAmount)
            if (checkDisableBetBtn()) {
                setDoubleDisabled(true)
            } else {
                setDoubleDisabled(false)
            }
            if (props.gameState.betRequest?.betString && !totalAmount && !props.gameState.takeAmount) {
                setBetBtn(props.language.Prev)
            } else if (props.gameState.takeAmount) {
                setBetBtn(props.language.TAKE)
            } else {
                setBetBtn(props.language.BetOK)
            }
        }
    }, [betObject])

    const restartGame = () => {

    }

    const playTheSound = (sound, isLoopd = false, delay = 0) => {

        // Stop currently playing sound (unless you want overlapping sounds)
        if (playingSound.current) {
            playingSound.current.stop();
            clearTimeout(soundLoopTimeout.current)
            soundLoopTimeout.current = null
        }

        // Choose new sound
        const soundObj = soundsRef.current[sound];
        playingSound.current = soundObj;

        if (!playingSound.current) return;
        if (isLoopd) {
            // Enable / Disable looping
            playingSound.current.loop(isLoopd);
            soundLoopTimeout.current = setTimeout(() => {
                playingSound.current.play();
            }, delay)
        } else {
            // Play sound
            playingSound.current.play();
        }
    };


    const backgroundStyle = useMemo(() => ({
        backgroundImage: `url(${AAA_Demo_img})`,
    }), []);

    const handleOrientationChange = () => {
        const { innerWidth: w, innerHeight: h } = window;

        if (h < w) {
            setBetPlacedChipSize(prev => prev !== 90 ? 90 : prev); // Landscape
        } else {
            setBetPlacedChipSize(prev => prev !== 175 ? 175 : prev); // Portrait
        }
    }

    const checkGameState = () => {
        if (props.gameState.handId !== props.gameState.oldHandId && !isInitial.current) {
            const timer = setTimeout(() => {
                setWinAmount(0)
                setShowWinAmount(false)
                aaaAnimationRef.current.setJokerToHistory(true)
                setIsBetFreezed(false)
                clearAllBets()
            }, 3000);

            return () => clearTimeout(timer);
        } else if (props.gameState.handId === props.gameState.oldHandId && isFGA.current && props.gameState.takeAmount) {
            setBetAmount(props.gameState.response.betAmount)
            setWinAmount(props.gameState.takeAmount)
            setBetBtn(props.language.TAKE)
            aaaAnimationRef.current.setJokerCard(props.gameState.response.card)
        }
    }

    const validateBet = ({
        betObj,
        betPlacedOn,
        chipValue,
        betAmount,
        balance,
        minBetAmt,
        maxBetAmt,
        innerLimits,
        isBetFreezed
    }) => {

        if (isBetFreezed) {
            return { isValid: false, message: null }
        }

        // Split inner limits for Amar | Akbar | Anthony
        const limitsArray = innerLimits.split("|")  // ["1-1000", "1-1000", "1-1000"]

        let limitIndex = 0
        if (betPlacedOn === "Amar") limitIndex = 0
        else if (betPlacedOn === "Akbar") limitIndex = 1
        else if (betPlacedOn === "Anthony") limitIndex = 2

        const [minInner, maxInner] = limitsArray[limitIndex]
            .split("-")
            .map(Number)

        // Running total for this particular bet
        const betPlaceAmount = (betObj[betPlacedOn] ?? 0) + chipValue

        const newBetAmount = betAmount + chipValue
        const updatedBalance = balance - newBetAmount

        if (!chipValue) {
            return { isValid: false, message: null }
        }

        // Table min/max limit check
        if (newBetAmount < minBetAmt || newBetAmount > maxBetAmt) {
            return {
                isValid: false,
                message: `Min Bet ${minBetAmt}\nMax Bet ${maxBetAmt}`
            }
        }

        // Balance validation
        if (updatedBalance < 0 || newBetAmount > balance) {
            return {
                isValid: false,
                message: props.language.Low_Balance
            }
        }

        // Inner limit validation
        if (betPlaceAmount < minInner || betPlaceAmount > maxInner) {
            return {
                isValid: false,
                message: `Inner Limit for ${betPlacedOn} is ${minInner}-${maxInner}`
            }
        }

        return { isValid: true, message: null }
    }

    const clickOnBet = (betPlacedOn) => {
        let betObj = { ...betObject }
        let chipValue = Number(selectedChip.value)

        const { isValid, message } = validateBet({
            betObj,
            betPlacedOn,
            chipValue,
            betAmount,
            balance: props.balance,
            minBetAmt: props.minBetAmt,
            maxBetAmt: props.maxBetAmt,
            innerLimits: props.aaa_innerLimits,  // Amar|Akbar|Anthony
            isBetFreezed
        })

        if (!isValid) {
            if (message) setInfoText(message)
            playTheSound("invalidBet")
            return
        }

        betObj[betPlacedOn] = changeAmountToFixed((betObj[betPlacedOn] ?? 0) + chipValue, 2)

        setWinner("")
        setBetObject({ ...betObj })
        playTheSound("betChipSound")
        setInfoText(props.language.Click_BetOk)
    }



    const buttonClicked = (type) => {
        switch (type) {
            case props.language.Clear: clearAllBets(); break;
            case props.language.BetOK: sendBetRequest(); break;
            case props.language.Double: doubleAllBets(); break;
            case props.language.Prev: setPreviousBetRequest(); break;
            case props.language.TAKE: sendTakeAction(); break;
            default: break;
        }
    }

    const clearAllBets = () => {
        playTheSound("clearSound")
        setBetObject({})
        setInfoText(props.language.AAA_BetMsg)
    }

    const doubleAllBets = () => {
        if (isBetFreezed) return false

        const betObj = { ...betObject }

        const limitsArray = props.aaa_innerLimits.split("|")
        const indexMap = { Amar: 0, Akbar: 1, Anthony: 2 }

        let currentTotal = 0
        let additionalTotal = 0
        let canDouble = false

        let innerLimitErrors = []
        let updatedBets = {}

        // First pass → evaluate each bet
        for (let betPlacedOn in betObj) {
            const currentBet = Number(betObj[betPlacedOn])
            if (!currentBet) continue

            currentTotal += currentBet

            const [_, maxInner] = limitsArray[indexMap[betPlacedOn]]
                .split("-")
                .map(Number)

            const doubledBet = currentBet * 2

            // Inner limit check
            if (doubledBet > maxInner) {
                innerLimitErrors.push(
                    // `${betPlacedOn} limit is ${maxInner}`
                    `Max inner-limit is ${maxInner}`
                )
                updatedBets[betPlacedOn] = currentBet
                continue
            }

            // Allowed to double
            canDouble = true
            additionalTotal += currentBet
            updatedBets[betPlacedOn] = doubledBet
        }

        const newTotal = currentTotal + additionalTotal

        // ❌ Nothing can be doubled → show alert
        if (!canDouble) {
            // Priority 1 → Inner limit message
            if (innerLimitErrors.length) {
                setInfoText(innerLimitErrors[0])
                return false
            }

            // Priority 2 → Max bet
            if (newTotal > props.maxBetAmt) {
                setInfoText(`Max Bet ${props.maxBetAmt}`)
                return false
            }

            // Priority 3 → Balance
            if (newTotal > props.balance) {
                setInfoText(props.language.Low_Balance)
                return false
            }

            return false
        }

        // Final validations (only if at least one bet can double)
        if (newTotal > props.maxBetAmt) {
            setInfoText(`Max Bet ${props.maxBetAmt}`)
            return false
        }

        if (newTotal > props.balance) {
            setInfoText(props.language.Low_Balance)
            return false
        }

        // ✅ Apply only valid doubles
        playTheSound("betChipSound")
        setBetObject(prev => ({
            ...prev,
            ...updatedBets
        }))

        return true
    }




    const sendBetRequest = () => {
        if (betAmount > props.balance || betAmount < props.minBetAmt || betAmount > props.maxBetAmt || isBetFreezed) {
            return
        }

        let body = {
            "sessionId": sessionStorage.getItem("sessionId"),
            "CN": "AMAR_AKBAR_ANTHONY_BET",
            "object": {
                "gameId": Number(props.gameId),
                "playerId": props.playerId,
                "betAmount": Number(betAmount),
                "action": "AMAR_AKBAR_ANTHONY_BET",
                "handId": Number(props.gameState.handId),
                "betString": `${betObject.Amar ?? 0}|${betObject.Akbar ?? 0}|${betObject.Anthony ?? 0}`,
            },
        }
        betRequestTimeOut.current = setTimeout(() => {
            if (betRequestTimeOut.current) {
                props.showTimeOut("Re-Connecting......!\n Please Click on Refresh");
                betRequestTimeOut.current = null;
            }
        }, 5000);
        playTheSound("buttonClick")
        setInfoText(props.language.Bet_Processing_Msg)
        setIsBetFreezed(true)
        props.network?.sendof(body)
    }

    const updateMessage = () => {
        setInfoText(props.infoText)
    };

    const sendTakeAction = () => {
        setIsBetFreezed(true)
        props.callTakeAmount()
        getGameStatePlayerBalance()
    }

    const setPreviousBetRequest = () => {
        if (props.gameState.handId !== props.gameState.oldHandId &&
            props.gameState.betRequest) {

            let [amar, akbar, anthony] =
                props.gameState.betRequest.betString.split("|").map(Number)

            let prevObj = { Amar: amar, Akbar: akbar, Anthony: anthony }
            let currentObj = { ...betObject }
            let newBetAmt = 0

            for (let key of ["Amar", "Akbar", "Anthony"]) {
                if (prevObj[key] > 0) {

                    const { isValid, message } = validateBet({
                        betObj: currentObj,
                        betPlacedOn: key,
                        chipValue: prevObj[key],
                        betAmount: newBetAmt,
                        balance: props.balance,
                        minBetAmt: props.minBetAmt,
                        maxBetAmt: props.maxBetAmt,
                        innerLimits: props.aaa_innerLimits,
                        isBetFreezed
                    })

                    if (!isValid) {
                        if (message) setInfoText(message)
                        playTheSound("invalidBet")
                        return
                    }

                    currentObj[key] = prevObj[key]
                    newBetAmt += prevObj[key]
                }
            }

            playTheSound("buttonClick")
            setBetObject({ ...currentObj })
            setWinner("")
        }
    }



    const checkAmarAkbarAntonyResult = (result) => {
        clearTimeout(betRequestTimeOut.current);
        betRequestTimeOut.current = null;
        aaaAnimationRef.current.setJokerCard(result.card)
        setInfoText(`${props.language.BetAccepted} ${result.betAmount}`)
        playTheSound("cardFallSound")
        if (result.winAmount) {
            if (isFGA.current) {
                setIsBetFreezed(false)
                setBetBtn(props.language.TAKE)
            }
        }
    }

    const setPlayerWinner = () => {
        if (props.AmarAkbarAntonyResult?.card) {
            setWinner(getWinner(props.AmarAkbarAntonyResult.card))
            setInfoText(props.AmarAkbarAntonyResult.message || `${props.language.BetAccepted} ${props.AmarAkbarAntonyResult.betAmount}`)
        } else {
            setWinner(getWinner(props.gameState.response.card))
            setInfoText(props.language.Click_Take)
        }
    }

    const getWinner = (title) => {
        const rank = title.charAt(0);

        if (["A", "2", "3", "4", "5", "6"].includes(rank)) return "Amar";
        if (["7", "8", "9", "10", "T"].includes(rank)) return "Akbar";
        if (["J", "Q", "K"].includes(rank)) return "Anthony";

        return ""; // fallback
    }

    const getGameStatePlayerBalance = () => {
        props.gamstateHandle()
        props.playerBalanceHandle()
    }


    const checkDisableBetBtn = () => {
        const bets = Object.values(betObject);

        const limits = props.aaa_innerLimits
            .split("|")
            .map(item => Number(item.split("-")[1])); // max only

        return bets.every((bet, index) => {
            return !bet || bet * 2 > limits[index];
        });
    };


    return <div id="AmarAkbarAntonyGame" className="AmarAkbarAntonyGame" style={backgroundStyle}>
        <div id="AAA_userDetails">
            <div id="balanceImage" className="balWinImage">
                <div className="iconCircle">
                    <img src={balance_img} className="aaa_icon" alt="" />
                </div>
                <span className="userBalanceTxt">{changeAmountToFixed(props.balance - dupBetAmount, 2)}</span>
            </div>
            <div id="titleImage">
                <span className="titleTxt"><span style={{ color: "#f1ff05" }}>Amar</span> <span style={{ color: "#fff" }}>Akbar</span> <span style={{ color: "#f1ff05" }}>Anthony</span></span>
            </div>
            <div id="totalBetAmount" className="balWinImage">
                <div className="iconCircle">
                    <img src={betChip_img} height={"45px"} className="aaa_icon winCupImg" style={{ rotate: "45deg" }} alt="" />
                </div>
                <span className="winAmountTxt">{betAmount}</span>
            </div>
            <div id="winImage" className="balWinImage">
                <div className="iconCircle">
                    <img src={winCup_img} height={"65px"} className="aaa_icon winCupImg" style={{ rotate: "45deg" }} alt="" />
                </div>
                <span className="winAmountTxt">{winAmount}</span>
            </div>
        </div>
        <div id="playerDetails">
            <div className="AAA_handId">{props.language.Hand_Id} {props.gameState.handId}</div>
            <div className="AAA_playerName">{props.user}</div>
            <div className="AAA_playerId">{props.language.Player_Id} {props.playerId}</div>
        </div>
        <AmarAkbarAntonyAnimationLayer
            ref={aaaAnimationRef}
            history={props.gameState.history}
            infoText={infoText}
            setPlayerWinner={setPlayerWinner}
            playTheSound={playTheSound}
        ></AmarAkbarAntonyAnimationLayer>
        <AmarAkbarAntonyBoard
            gameId={props.gameId}
            aaa_chipValues={props.aaa_chipValues}
            betObj={betObject}
            language={props.language}
            betBtn={betBtn}
            betAmount={betAmount}
            selectedChip={selectedChip}
            setSelectedChip={setSelectedChip}
            isBetFreezed={isBetFreezed}
            playTheSound={playTheSound}
            maxBetAmt={props.maxBetAmt}
            clickOnBet={clickOnBet}
            winner={winner}
            buttonClicked={buttonClicked}
            winAmount={winAmount}
            showWinAmount={showWinAmount}
            betPlacedChipSize={betPlacedChipSize}
            setShowWinAmount={setShowWinAmount}
            isDoubleDisabled={isDoubleDisabled}
        ></AmarAkbarAntonyBoard>
        <div className="AAA_info_Div" onClick={() => { setShowGameRules(true) }}>
            <img src={info_img} className="AAA_info_img"></img>
            <p className="AAA_info_Icon">i</p>
        </div>
        {showGameRules && <AmarAkbarAnthonyGameRules
            minBetAmt={props.minBetAmt}
            maxBetAmt={props.maxBetAmt}
            innerLimits={props.aaa_innerLimits}
            payoutInfo={props.game_PayoutInfo}
            close={() => { setShowGameRules(false) }}
        ></AmarAkbarAnthonyGameRules>}
        {enterPopUp && <div className="iosFetchSounds" id="iospopup" onClick={(e) => setEnterPopUp(false)}>
            <div className="popupTooLong">
                <div className="mt-2">{props.language.Wel_AAA}</div>
                {props.language?.OK_Btn}
                <br></br>
                <br></br>
                <div className="fd">
                    <button className="btn_iosPopup"> OK </button>
                    <br></br>
                </div>
            </div>
        </div>}
    </div>
})


export default memo(AmarAkbarAntony)